/* eslint-disable @typescript-eslint/no-magic-numbers */
interface RemoteAccessResponseActive {
  statusCode: 200;
  message: 'Success';
  result: {
    status: 'IdentifierActive';
    phoneNumber: string;
    salesChannel: RemoteKind;
    agent: {
      agentName: string;
      phoneNumber: string;
      email: string;
    };
  };
  errors: null;
  timeGenerated: string;
}

interface RemoteAccessResponseInactive {
  statusCode: 200;
  message: 'Success';
  result: {
    status: 'IdentifierInactive';
    phoneNumber: null;
    salesChannel: RemoteKind;
    agent: {
      agentName: string;
      phoneNumber: string;
      email: string;
    };
  };
  errors: null;
  timeGenerated: string;
}

export type RemoteAccessResponseSuccess = RemoteAccessResponseActive | RemoteAccessResponseInactive;

export interface RemoteAccessResponseError {
  statusCode: number;
  message: 'Failure';
  result: null;
  errors: {
    code: string;
    userMessage: string;
  }[];
  timeGenerated: string;
}

export enum RemoteKind {
  B2C = 'B2C',
  TravelAgency = 'TravelAgency',
}
